<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">Packout Report</h2>
      <span class="page-subtitle">Packout totals by code, with the {{"lots" | tenantWords}} packed into each</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="exportExcel()"
        [disabled]="this.isLoading || !this.rows.length">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <kw-filter-dropdown class="filter-widget" [filterSettings]="this.kwFilterSettings"
      (filterResultsChange)="search($event)">
      <div kwFilterInline class="search-box">
        <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
        <input type="text" placeholder="Search by packout code or {{'lot' | tenantWords}}..."
          [(ngModel)]="searchTerm" (ngModelChange)="applySearch()" class="search-input" aria-label="Search packouts">
      </div>
    </kw-filter-dropdown>
  </div>

  <div class="grid-card static">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [detailTemplate]="this.detailTemplate"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="toggleLots(row)">
      <div class="m-card-top">
        <span class="m-card-name">{{row.packoutCode || '—'}}</span>
        <span class="type-pill">{{row.totalQuantity | number:'1.0-2'}}</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.date">
          <fa-icon [icon]="faCalendar" class="m-meta-icon"></fa-icon>{{row.date | date:'M/d/y'}}
        </div>
        <div class="m-meta-line">
          <fa-icon [icon]="faLayerGroup" class="m-meta-icon"></fa-icon>
          {{row.lotMassBalances?.length || 0}} {{"lots" | tenantWords}}
        </div>
      </div>

      <div class="m-lot-list" *ngIf="this.expandedCodes.has(row.packoutCode)">
        <div class="m-lot" *ngFor="let lot of row.lotMassBalances">
          <span class="m-lot-number">{{lot.lotNumber}}</span>
          <span class="m-lot-date">{{lot.date | date:'M/d/y'}}</span>
          <span class="m-lot-qty">{{lot.balance | number:'1.0-2'}}</span>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faBoxOpen" class="m-empty-icon"></fa-icon>
      <div>No packouts match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #detailTemplate let-data>
  <div class="lot-detail">
    <ejs-grid [dataSource]="data.lotMassBalances" [columns]="this.lotColumns"></ejs-grid>
  </div>
</ng-template>
